import React from "react";
import { SxProps, Theme } from "@mui/material";
import { LicenseStylesColums } from "./LicenseColumns";

/** Shared credit cell box (balance & totalCreditsSinceStart columns) */
export const creditBoxSx: SxProps<Theme> = {
  display: "flex",
  flexDirection: "column",
  gap: "3px",
  width: "100%",
};

/** Bold small text inside credit cells */
export const creditLabelStyle: React.CSSProperties = {
  fontWeight: 600,
  fontSize: "0.85rem",
};

/** Row wrapping a credit value and its hover-hint icon */
export const cellValueWithIconSx: SxProps<Theme> = {
  display: "inline-flex",
  alignItems: "center",
  gap: 0.5,
};

/** Small icon inviting the user to hover the credit cells */
export const cellHelpIconSx: SxProps<Theme> = {
  fontSize: 14,
  color: "#1565c0",
  opacity: 0.7,
};

/** Dimmed dash shown when no pending credits */
export const noPendingStyle: React.CSSProperties = {
  color: "rgba(0,0,0,0.38)",
};

/** Pending-pack chip (extra column) */
export const pendingChipSx: SxProps<Theme> = {
  backgroundColor: "#e3f2fd",
  color: "#1565c0",
  fontWeight: 600,
};

/** Status badge pill with dynamic color/background */
export const statusBadgeStyle = (
  color: string,
  bg: string,
): React.CSSProperties => ({
  ...LicenseStylesColums.statusBadge,
  color,
  backgroundColor: bg,
});

/** Status indicator dot with dynamic background */
export const statusDotStyle = (color: string): React.CSSProperties => ({
  ...LicenseStylesColums.statusDot,
  backgroundColor: color,
});

/** Expiry chip with conditional transparent background when expired */
export const expiryChipStyle = (isExpired: boolean): React.CSSProperties => ({
  ...LicenseStylesColums.expiryChip,
  backgroundColor: isExpired
    ? "transparent"
    : LicenseStylesColums.statusColors.expired.bg,
});

/** Help icon shown in the extra-pack column */
export const helpIconSx: SxProps<Theme> = { color: "#1565c0", ml: 0.5 };

/** Inline-flex wrapper for tooltip children */
export const tooltipWrapperSx: SxProps<Theme> = { display: "inline-flex" };

/** Shared slotProps for the custom packs tooltip */
export const packTooltipSlotProps = {
  tooltip: {
    sx: {
      bgcolor: "background.paper",
      color: "text.primary",
      boxShadow: 4,
      p: 0,
      maxWidth: 420,
    },
  },
  arrow: { sx: { color: "background.paper" } },
};
